module.exports = __webpack_public_path__ + "images/07045314d601b9eecf485a0bafb5a271.png";